import { ROLE_LABELS } from '@/constants';
import { TUserRole } from '@/types';

/**
 * Utility function to standardize user role values across different user object types.
 * It maps various role strings to a consistent set of user roles used in the application.
 */
export function getUserRole(role: TUserRole | string | null): typeof ROLE_LABELS | string {
  return ROLE_LABELS[role as keyof typeof ROLE_LABELS] || (role ? role : 'Unknown Role');
}
